// React
import React, { useEffect, useState } from 'react';

// Containers Injections
import { ModalBalanceHasReduced } from '../../containers/componentsInjection';
import { BillsToReceiveInjection } from '../../containers/billsToReceiveInjection';

// Yup & Formik
import * as Yup from 'yup';
import { useFormik } from 'formik';

// View
import { BillsToReceiveFormPage } from './view';

// Helpers
import { APIClient } from '../../../../helpers/api_helper';

export const BillsToReceiveForm = ({
  isOpen,
  toggle,
  isPartial,
  billsByHash,
  setIsPartial,
  selectedFile,
  setBillsByHash,
  setSelectedFile,
  isConfirmAction,
  setIsConfirmAction,
}) => {
  const [isOpen2, setIsOpen2] = useState(false);
  const [dataToSubmit, setDataToSubmit] = useState(null);
  const [paymentMethods, setPaymentMethods] = useState([]);
  const [hasBalanceReduced, setHasBalanceReduced] = useState(false);

  const api = new APIClient();
  let currentDate = new Date().toJSON().slice(0, 10);

  const {
    offices,
    accounts,
    getOffices,
    getAccounts,
    organizations,
    createBillsToPay,
    getOrganizations,
    updateBillsToPay,
    categoryFinanceOrganized,
    getFinancialCategoriesOrganized,
  } = BillsToReceiveInjection();

  const toggleHasBalanceReduced = () => {
    setHasBalanceReduced((prevState) => !prevState);
  };

  function verifyIfBalanceHasReduced(initialBalance, balance) {
    if (balance < initialBalance) {
      return true;
    } else {
      return false;
    }
  }

  const getPaymentMethodsOptions = async () => {
    await api.get('/register/payment-method').then((payment) => {
      setPaymentMethods(payment);
    });
  };

  const handleEdit = (id, values) => {
    updateBillsToPay(id, values);
    validation.resetForm();
    toggle();
  };

  const handleConfirmation = (id, values) => {
    if (
      verifyIfBalanceHasReduced(
        parseInt(billsByHash.value),
        values.payment_value
      )
    ) {
      toggleHasBalanceReduced();
    } else {
      updateBillsToPay(id, values);
      validation.resetForm();
      toggle();
    }
  };

  const handleConfirmWhenBalanceHasReduce = (partial, values) => {
    updateBillsToPay(billsByHash.id, {
      ...values,
      partial,
    });
    toggleHasBalanceReduced();
    toggle();

    if (partial) {
      setIsPartial(true);
      setIsConfirmAction(false);
      setBillsByHash({
        ...values,
        value: parseInt(billsByHash.value) - values.payment_value,
        due_date: currentDate,
        financial_account_name: billsByHash.financial_account_name,
        financial_category_name: billsByHash.financial_category_name,
        financial_center_name: billsByHash.financial_center_name,
        office_name: billsByHash.office_name,
        payment_method_name: billsByHash.payment_method_name,
        person_name: billsByHash.person_name,
        description: `${billsByHash.description} (resíduo)`,
      });
      setTimeout(() => {
        toggle();
      }, 2000);
    } else {
      validation.resetForm();
    }
  };

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      // principal
      balance: billsByHash ? parseInt(billsByHash.value) : null,
      expirationDate: !billsByHash
        ? ''
        : isConfirmAction
        ? currentDate
        : billsByHash?.due_date,
      documentNumber: billsByHash ? billsByHash.number : '',
      description: billsByHash ? billsByHash.description : '',
      organization: billsByHash
        ? {
            value: billsByHash.organization_id,
            label: billsByHash.organization_name,
          }
        : {
            value: '',
            label: '',
          },
      category: billsByHash
        ? {
            value: billsByHash.financial_category_id,
            label: billsByHash.financial_category_name,
          }
        : {
            value: '',
            label: '',
          },
      account: billsByHash
        ? {
            value: billsByHash.financial_account_id,
            label: billsByHash.financial_account_name,
          }
        : {
            value: '',
            label: '',
          },
      paymentMethod: billsByHash
        ? {
            value: billsByHash.payment_method_id,
            label: billsByHash.payment_method_name,
          }
        : {
            value: '',
            label: '',
          },
      observations: billsByHash ? billsByHash.notes : '',
      office: billsByHash
        ? {
            value: billsByHash.office_id,
            label: billsByHash.office_name,
          }
        : {
            value: '',
            label: '',
          },
    },

    validationSchema: Yup.object().shape({
      balance: Yup.string().nullable().required(),
      expirationDate: Yup.string().nullable().required(),
      documentNumber: Yup.string().nullable(),
      organization: Yup.object().shape({
        label: Yup.string(),
        value: Yup.string().required(),
      }),
      category: Yup.object().shape({
        label: Yup.string(),
        value: Yup.string().required(),
      }),
      account: Yup.object().shape({
        label: Yup.string().nullable(),
        value: Yup.string().nullable(),
      }),
      office: Yup.object().shape({
        label: Yup.string(),
        value: Yup.string().required(),
      }),
      paymentMethod: Yup.object().shape({
        label: Yup.string().nullable(),
        value: Yup.string().nullable(),
      }),
      observations: Yup.string().nullable(),
      description: Yup.string().nullable().required(),
    }),

    onSubmit: (values) => {
      let dynamicVarNameToBalance = isConfirmAction ? 'payment_value' : 'value';
      let dynamicVarNameToExpirationDate = isConfirmAction
        ? 'payment_date'
        : 'due_date';

      let valuesToSubmit = {
        repeat: 'u',
        type: 'r',
        financial_account_id: values.account.value || null,
        financial_category_id: values.category.value,
        payment_method_id: values.paymentMethod.value || null,
        office_id: values.office.value,
        number: values.documentNumber || null,
        description: values.description,
        organization_id: values.organization.value,
        notes: values.observations || null,
        file: selectedFile[0] || null,
      };

      valuesToSubmit[dynamicVarNameToBalance] = values.balance;
      valuesToSubmit[dynamicVarNameToExpirationDate] = values.expirationDate;

      if (billsByHash && !isPartial) {
        setDataToSubmit(valuesToSubmit);
        if (isConfirmAction) {
          handleConfirmation(billsByHash.id, valuesToSubmit);
        } else {
          handleEdit(billsByHash.id, valuesToSubmit);
        }
      } else {
        createBillsToPay(valuesToSubmit);
        validation.resetForm();
        setIsPartial(false);
        toggle();
      }
    },
  });

  useEffect(() => {
    getOffices();
    getAccounts();
    getOrganizations();
    getPaymentMethodsOptions();
    getFinancialCategoriesOrganized('r');
  }, []);

  const toggle2 = () => {
    setIsOpen2((prevState) => !prevState);
  };

  return (
    <>
      <BillsToReceiveFormPage
        // data
        offices={offices}
        accounts={accounts}
        organizations={organizations}
        paymentMethods={paymentMethods}
        isUpdate={!isPartial && billsByHash}
        lastUpdated={billsByHash?.last_update}
        categories={categoryFinanceOrganized}
        // utils
        isOpen={isOpen}
        toggle={toggle}
        toggle2={toggle2}
        isOpen2={isOpen2}
        validation={validation}
        selectedFile={selectedFile}
        setSelectedFile={setSelectedFile}
        isConfirmAction={isConfirmAction}
      />

      <ModalBalanceHasReduced
        validation={validation}
        isOpen={hasBalanceReduced}
        toggle={toggleHasBalanceReduced}
        handleSubmit={(partial) => {
          handleConfirmWhenBalanceHasReduce(partial, dataToSubmit);
        }}
      />
    </>
  );
};
